function sanitizeUrl(input) {
  if (input === void 0) {
    return void 0;
  }
  const url = (() => {
    try {
      return new URL(input, "http://localhost/");
    } catch {
    }
  })();
  if (!url) {
    return void 0;
  }
  switch (url.protocol) {
    case "http:":
    case "https:":
    case "ftp:":
    case "mailto:":
    case "tel:":
      return input;
    default:
      return void 0;
  }
}

export { sanitizeUrl };
//# sourceMappingURL=common.html.sanitize-url.js.map
